import { Injectable } from '@angular/core';
import { Address } from 'odq-toolbox';
import { Observable, of } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { MunicipalityCommandService } from './municipalities-command.service';
import { MunicipalityQueryService } from './municipalities-query.service';
import { Municipality } from './municipalities.model';

@Injectable({
  providedIn: 'root',
})
export class MunicipalityUtilsService {

  constructor(
    private municipalityQueryService: MunicipalityQueryService,
    private municipalityCommandService: MunicipalityCommandService,
  ) { }

  generateUniqueMunicipalityCode(municipalities: Municipality[]): string {
    if (!municipalities || municipalities.length === 0) {
      return 'WXYZ';
    }

    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    while (true) {
      let result = '';

      for (let i = 4; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];

      if (
        !municipalities
          ?.filter(c => !!c?.code)
          .map(c => c?.code?.trim()?.toUpperCase())
          ?.includes(result)
      ) {
        return result;
      }
    }
  }

  provideMunipalityCodeForAddress(address: Address): Observable<string> {
    // Check for municipality. If exists return code; else add municipality, then return code
    return this.municipalityQueryService.getMunicitalityByName(address.city.toUpperCase()).pipe(
      take(1),
      mergeMap(municipality => {
        if (!!municipality) {
          return of(municipality.code);
        } else {

          return this.municipalityQueryService.getMany().pipe(
            take(1),
            mergeMap(municipalities => {
              const municipalityToAdd = {
                name: address.city.toUpperCase(),
                provinceIsoCode: address.provinceCode,
                countryIsoCode2: address.countryCode,
                code: this.generateUniqueMunicipalityCode(municipalities),
              } as Municipality;
              return this.municipalityCommandService.registerMunicipality(municipalityToAdd).pipe(
                map(_ => municipalityToAdd.code),
              );
            }),
          );
        }
      }),
    );
  }

}
